
import GenericPopup from './genericPopup'
export default GenericPopup;